// extracted by mini-css-extract-plugin
module.exports = {"LinkPrincipal":"LinkPrincipal_LinkPrincipal__2LyML","Icon":"LinkPrincipal_Icon__1AUVL","Label":"LinkPrincipal_Label__2tiio"};